// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CarouselInfinite__carousel-wrapper-e0c5b8 {
  overflow: hidden;
}

.CarouselInfinite__carousel-edeb89 {
  display: flex;
  flex-direction: row;
  width: 100%;
}

.CarouselInfinite__carousel-item-fa88b6 {
  flex: 0 0 auto;
  box-sizing: border-box;
}`, "",{"version":3,"sources":["webpack://./../../packages/components/src/Carousel/CarouselInfinite/CarouselInfinite.styles.m.css"],"names":[],"mappings":"AAAA;EACE,gBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;AACF;;AAEA;EACE,cAAA;EACA,sBAAA;AACF","sourcesContent":[".carousel-wrapper {\n  overflow: hidden;\n}\n\n.carousel {\n  display: flex;\n  flex-direction: row;\n  width: 100%;\n}\n\n.carousel-item {\n  flex: 0 0 auto;\n  box-sizing: border-box;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"carousel-wrapper": `CarouselInfinite__carousel-wrapper-e0c5b8`,
	"carouselWrapper": `CarouselInfinite__carousel-wrapper-e0c5b8`,
	"carousel": `CarouselInfinite__carousel-edeb89`,
	"carousel-item": `CarouselInfinite__carousel-item-fa88b6`,
	"carouselItem": `CarouselInfinite__carousel-item-fa88b6`
};
module.exports = ___CSS_LOADER_EXPORT___;
